import { Component } from '@angular/core';
import { RegisterHeaderComponent } from '../shared/register-header.component';

@Component({
  selector: 'app-page-not-found',
  standalone: true,
  imports: [RegisterHeaderComponent],
  templateUrl: './page-not-found.component.html',
  styleUrl: './page-not-found.component.css'
})
export class PageNotFoundComponent {

}
